export default "__VITE_ASSET__64898c05__"